module.exports = __webpack_public_path__ + "static/media/reports-green.31bc9e5d.svg";